import React from "react";
import {Route} from "react-router-dom";

const module = (shopApp) => {
	const NewsletterCancelation = shopApp.dynamic(() => import("./NewsletterCancelation"));

	const url = "/newsletter/cancelation";

	let config = {
		name: "NewsletterCancelation",
		routes: [
			<Route key={url} exact path={url} component={NewsletterCancelation}/>
		]
	};

	shopApp.registerPage(config);

};

export default module;
